import {CardsInterfaceState, initialCardState} from '../state/cards.state';
import {CardsActions, ECardsActions} from '../actions/cards.actions';

export function cardsReducer(state: CardsInterfaceState = initialCardState, action: CardsActions): CardsInterfaceState {
  switch (action.type) {
    case ECardsActions.GetCardsSuccess: {
      return {...state, cards: action.payload};
    }

    default:
      return state;
  }
}
